var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose24Px = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.707 4.707a1 1 0 0 0-1.414-1.414zM3.293 19.293a1 1 0 1 0 1.414 1.414zm16-16-16 16 1.414 1.414 16-16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.293 20.707a1 1 0 0 0 1.414-1.414zM4.707 3.293a1 1 0 0 0-1.414 1.414zm16 16-16-16-1.414 1.414 16 16z"
})));
export default SvgClose24Px;